var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.44434V12.9999",
    stroke: "#951212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9379 5.57989L4.16499 16.5942C4.05709 16.7702 4.00019 16.9697 4 17.1729C3.99981 17.3761 4.05633 17.5757 4.1639 17.7519C4.27146 17.928 4.4263 18.0744 4.6129 18.1765C4.7995 18.2785 5.01131 18.3326 5.2271 18.3333H18.7729C18.9887 18.3326 19.2005 18.2785 19.3871 18.1765C19.5737 18.0744 19.7285 17.928 19.8361 17.7519C19.9437 17.5757 20.0002 17.3761 20 17.1729C19.9998 16.9697 19.9429 16.7702 19.835 16.5942L13.0621 5.57989C12.955 5.40371 12.8004 5.25729 12.6139 5.15546C12.4274 5.05363 12.2156 5 12 5C11.7844 5 11.5726 5.05363 11.3861 5.15546C11.1996 5.25729 11.045 5.40371 10.9379 5.57989V5.57989Z",
    stroke: "#951212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3891 15.6667C12.3891 15.8815 12.215 16.0556 12.0002 16.0556C11.7854 16.0556 11.6113 15.8815 11.6113 15.6667C11.6113 15.4519 11.7854 15.2778 12.0002 15.2778C12.215 15.2778 12.3891 15.4519 12.3891 15.6667Z",
    fill: "#951212",
    stroke: "#951212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f599e119cf6ee6d8d0bb32f453413a9f.svg";
export { ForwardRef as ReactComponent };